import { Injectable } from '@angular/core';
import { Simulation } from '../../../shared/modules/evc-api/models/simulation';
import { Quote, QuoteDetails } from '../../../shared/modules/evc-api/models/quote';
import { QuoteSteps } from '../models/quote-steps';
import { Status } from '../../../shared/modules/evc-api/models/constants';
import { PartnerUI } from '@app/shared/modules/evc-api/models/partner-ui.interface';

@Injectable({
  providedIn: 'root',
})
export class QuoteHelperService {
  static convertSimulationToQuote(simulation: Simulation, partner: PartnerUI, lang: string): Quote {
    const quote: Quote = {
      step: QuoteSteps.carDetails,
      stepReached: QuoteSteps.carDetails,
      simId: simulation.id,
      status: Status.inProgress,
      email: simulation.email,
      lang,
      quote: {
        carDetails: [],
        chargingStationDetails: {
          placement: `${simulation.placement}.simulation`,
        },
        technicalDetails: {
          electricPhase: `${simulation.phase}.simulation`,
          distance: `${simulation.distance}.simulation`,
        },
        houseDetails: {
          houseType: {
            houseType: `${simulation.houseType}.simulation`,
            ...(simulation.parking ? { parkingSpot: simulation.parking } : {}),
          },
        },
        personalDetails: {},
        partnerDetails: {
          ...(partner && partner.name ? { partner: partner.name } : {}),
          ...(partner && partner.resellerCode ? { resellerCode: partner.resellerCode } : {}),
        },
      } as QuoteDetails,
    };
    return quote;
  }
}
